export const PAGE_TYPE = {
    DEFAULT: 'lobby',
    LOBBY: 'lobby',
    NICKNAME: 'nickname',
    DEVICE: 'device',
    MAIN: 'main',
    ERROR: 'error'
};